<template>
  <div class="business-settings-inline-form">
    <v-form ref="editTaxesForm" @submit.prevent="submit">
      <v-card
        flat
      >
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-checkbox
                outlined
                dense
                class="mt-0"
                width="20%"
                color="#00BCD4"
                v-model="hasPnp"
                label="Porez na potrošnju"
              >
              </v-checkbox>
            </v-col>

            <v-col cols="6">
              <v-text-field
                dense
                outlined
                class="form-input"
                :disabled="!hasPnp"
                label="Poreza na potrošnju"
                hint="Postotak samo broj"
                persistent-hint
                @keypress="checkNumber($event)"
                v-model="pnp"
                :rules="[rules.req]"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="pl-5">
            <p style="font-size: 16px">
              Promjena poreza na potrošnju utječe na cijenu artikala.
              <br />Odaberite želite li promijeniti ukupnu cijenu artikla ili
              osnovicu artikla
            </p>
            <v-radio-group row v-model="pnpChangeType" color="#00BCD4">
              <v-radio label="Promijeni cijenu" value="price" />
              <v-radio label="Promijeni osnovnicu" value="base" />
            </v-radio-group>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-end form-footer-sticky">
          <v-btn
            class="btn-primary"
            :loading="submitting"
            :disabled="pnpSame"
            type="submit"
          >
            <v-icon left small color="#fff">mdi-content-save</v-icon>
            {{ $t("$vuetify.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>
<script>
import { clone } from '@/plugins/utils'
import rules from '@/plugins/rules'
import { df, auth } from '@/plugins/firebase'
import { v4 as uuidv4 } from 'uuid'
import requestChecker from '@/mixins/requestChecker'

export default {
  inject: ['showMsgBox'],
  mixins: [requestChecker],
  props: {
    location: {
      type: Object,
      required: true
    },
    company: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      submitting: false,
      editableLocation: {},
      hasPnp: false,
      pnp: 0,
      pnpChangeType: undefined,
      initialData: {},
      rules: {
        req: rules.req()
      }
    }
  },
  mounted () {
    this.editableLocation = clone(this.location)
    this.hasPnp = this.editableLocation.has_pnp ? this.editableLocation.has_pnp : false
    var pnp = this.editableLocation.pnp ? this.editableLocation.pnp / 100 : 0
    pnp = pnp.toFixed(2).replace('.', ',')
    this.pnp = pnp

    this.initialPnp = clone(this.pnp)
    this.initialHasPnp = clone(this.hasPnp)

    if (this.editableLocation.pnp_change_type) {
      this.pnpChangeType = this.editableLocation.pnp_change_type
    } else {
      this.pnpChangeType = 'base'
    }

    const params = {
      has_pnp: this.hasPnp ? this.hasPnp : false,
      pnp: this.pnp ? this.pnp : 0
    }

    this.initialData.hasPnp = clone(this.hasPnp)
    this.initialData.pnp = clone(this.pnp)
    this.initialData.pnpChangeType = clone(this.pnpChangeType)

    this.registerRequestParams(params)
  },
  computed: {
    pnpSame () {
      if (this.initialHasPnp === this.hasPnp && this.initialPnp === this.pnp) {
        return true
      }

      return false
    }
  },
  methods: {
    checkNumber (ev) {
      // change this with a custom directive  this accepts custom regex and checks input field
      const maskRe = /^([0-9]+)|([,])$/
      // const maskRe = /^([0-9]+)$/
      if (([','].some(sep => this.$attrs?.value?.toString()?.includes(sep)) && [','].some(sep => ev.key === sep)) || !maskRe.test(ev.key)) {
        ev.preventDefault()
        return false
      }
    },
    submit () {
      if (
        this.hasPnp === this.initialData.hasPnp &&
        this.pnp === this.initialData.pnp &&
        this.pnpChangeType === this.initialData.pnpChangeType
      ) {
        this.showMsgBox({ text: this.$t('$vuetify.errors.noChangesInEntities'), actions: ['ok'], cancelBtnText: 'OK', color: 'error' })
        return
      }

      if (!this.$refs.editTaxesForm.validate()) return

      if (this.editableLocation.has_pnp === this.hasPnp && this.editableLocation.pnp === this.pnp) {
        return
      }

      try {
        const reqId = uuidv4()
        const payload = {
          action: {
            operation: 'update',
            entity: 'location',
            resource_id: this.editableLocation.id,
            params: {
              company_id: this.company.id,
              has_pnp: this.hasPnp,
              pnp: this.pnp !== '' ? parseInt(parseFloat(this.pnp.replace(',', '.')) * 100) : 0
            }
          }
        }

        if (this.hasPnp === undefined || this.hasPnp === null) {
          payload.action.params.has_pnp = false
        }

        if (this.pnp === undefined || this.pnp === null) {
          payload.action.params.pnp = 0
        }

        if (this.pnpChangeType) {
          payload.action.params.pnp_change_type = this.pnpChangeType
        }

        if (payload.action.params.has_pnp === false) {
          payload.action.params.pnp = 0
        }

        // const cleanParams = this.getCleanParams(payload.action.params)
        // Object.keys(cleanParams).forEach((key) => {
        //   delete payload.action.params[key]
        // })

        df.doc(`request/${reqId}`)
          .set({
            user_id: `${auth.currentUser.uid}`,
            device_id: 'web',
            created: `${new Date().getTime()}`,
            type: 'location',
            payload: btoa(
              unescape(encodeURIComponent(JSON.stringify(payload)))
            )
          })
          .then(() => {
            this.$emit('saved', this.editableLocation)
          })
          .catch(function (error) {
            // console.error('Error writing document: ', error)
            this.showMsgBox({
              text: error || 'An error has occurred',
              actions: ['cancel'],
              cancelBtnText: 'OK',
              color: 'error'
            })
          })
          .finally(() => {
            this.submitting = false
          })
      } catch (err) {
        this.showMsgBox({
          text: err || 'An error has occurred',
          actions: ['cancel'],
          cancelBtnText: 'OK',
          color: 'error'
        })
        this.submitting = false
      }
    }
  }
}
</script>
<style scoped>
.form-input >>> .v-input__slot {
  border-radius: 12px !important;
  background: #ffffff !important;
  min-height: 40px !important;
}
.form-input >>> fieldset {
  border-color: #e5e7eb !important;
  border-width: 1px !important;
  border-radius: 12px !important;
}
.form-input >>> .v-input__slot:hover fieldset {
  border-color: #00BCD4 !important;
}
.form-input.v-input--is-focused >>> fieldset {
  border-color: #00BCD4 !important;
  border-width: 2px !important;
}
.form-input >>> input {
  font-size: 13px !important;
}
.btn-primary {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 11px 22px;
  background-color: #00BCD4 !important;
  color: #fff !important;
  border: none !important;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,188,212,0.3);
  transition: background-color 0.15s;
  text-transform: none !important;
}
.btn-primary:hover:not(:disabled) {
  background-color: #0097A7 !important;
}
.btn-primary:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  box-shadow: none;
}

.business-settings-inline-form {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.business-settings-inline-form>>>form {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.business-settings-inline-form>>>.v-card {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.business-settings-inline-form>>>.v-card__text {
  flex: 1 1 auto;
  overflow-y: auto;
  min-height: 0;
}

.form-footer-sticky {
  flex: 0 0 auto;
  background: #fff;
  border-top: 1px solid #F3F4F6;
  padding: 16px 24px !important;
}
</style>
